export class RfqSessionNudgeSettingTriggerTimingTargetDirectionType {
	public id: number;
	public name: string;

	constructor(rfqSessionNudgeSettingTriggerTimingTargetDirectionType?: RfqSessionNudgeSettingTriggerTimingTargetDirectionType) {
		Object.assign(this, rfqSessionNudgeSettingTriggerTimingTargetDirectionType);
	}
}
